export enum StoreListStatus {
  APPROVED = 'Approved',
  PENDING = 'Pending',
  BLOCKED = 'Blocked',
}

export interface StoreList {
  recommendationId: string;
  clubId: string;
  clubCategory: string;
  storeNameEng: string;
  storeNameJp: string;
  storeLogo: {
    path: string;
    alt: string;
    description: string;
  };
  displayId: string;
  displayPageLabel: string;
  displayOrder: string;
  requestedDate: number;
  status: StoreListStatus;
  updatedDate: number;
  groupId: string;
}

export interface GetMainPageStoreListParams {
  groupId: string;
  search?: string;
  row: number;
  fetch: number;
}
